import styled from 'styled-components';

// Modal de ayuda de la Timba: cómo se suman puntos + qué significan las tags (booster / bonus).
export function TimbaHelp({ onClose }: { onClose: () => void }) {
  return (
    <Backdrop onClick={onClose}>
      <Panel onClick={(e) => e.stopPropagation()}>
        <header>
          <h2>🎲 Cómo se juega la Timba</h2>
          <button type="button" aria-label="cerrar" onClick={onClose}>✕</button>
        </header>

        <p className="lead">
          Pronosticá el <b>marcador</b> de cada partido de la llave (y, si empatás, quién gana los penales).
          Cuanto más cerca le pegás, más sumás:
        </p>

        <h3>Puntos por partido</h3>
        <ul className="pts">
          <li><span className="b">+3</span> Acertar el resultado (gana 1 / empate / gana 2)</li>
          <li><span className="b">+5</span> Marcador exacto <em>(extra, total 8)</em></li>
          <li><span className="b">+1</span> Misma diferencia de gol <em>(si acertaste el resultado pero no el marcador, total 4)</em></li>
          <li><span className="b">+2</span> Acertar la tanda de penales <em>(en los empates)</em></li>
        </ul>

        <h3>Las tags</h3>
        <ul className="tags">
          <li>
            <span className="tag boost">×2</span>
            <div><b>Booster.</b> Multiplica los puntos del marcador de ese partido. Subís el multiplicador
              encadenando aciertos de quién avanza: <b>×2</b> en octavos, <b>×3</b> en cuartos, <b>×4</b> en semis…</div>
          </li>
          <li>
            <span className="tag llave">🔑 +2</span>
            <div><b>Bonus de llave.</b> En los cruces que pronostiques, sumás <b>+1 por cada equipo que acertás</b>
              que llega (el ganador de cada partido que alimenta el cruce), aunque le erres al marcador. Los dos = +2.</div>
          </li>
          <li>
            <span className="tag pot">×3 ⌁</span>
            <div><b>Potencial</b> (punteado). Lo que alcanzarías <em>si tus pronósticos se cumplen</em>.
              Cuando se juega el partido pasa a <b>confirmado</b> (sólido).</div>
          </li>
        </ul>

        <p className="foot">Tu identidad es anónima y vive solo en este dispositivo. Competí en la
          <b> Timba Mundial</b> o armá torneos privados con tus amigos. ¡Suerte! 🍀</p>

        <button type="button" className="ok" onClick={onClose}>Entendido</button>
      </Panel>
    </Backdrop>
  );
}

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 60;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0;
`;

const Panel = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth};
  max-height: 90vh;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: 18px 18px 0 0;
  padding: 18px 18px calc(18px + env(safe-area-inset-bottom));

  header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px; }
  header h2 { margin: 0; font-size: 1.25rem; }
  header button { background: none; border: none; color: ${({ theme }) => theme.colors.textMuted}; font-size: 1.2rem; }

  h3 { margin: 16px 0 8px; font-size: 0.95rem; color: ${({ theme }) => theme.colors.accent}; }
  .lead { margin: 0; font-size: 0.9rem; line-height: 1.5; color: ${({ theme }) => theme.colors.textMuted}; }
  .lead b { color: ${({ theme }) => theme.colors.text}; }

  ul { list-style: none; margin: 0; padding: 0; }
  .pts li {
    display: flex; align-items: baseline; gap: 10px; padding: 7px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border}; font-size: 0.9rem;
  }
  .pts .b { flex: 0 0 auto; min-width: 34px; font-weight: 900; color: ${({ theme }) => theme.colors.accent}; }
  .pts em { color: ${({ theme }) => theme.colors.textMuted}; font-style: normal; font-size: 0.82rem; }

  .tags li { display: flex; gap: 12px; align-items: flex-start; padding: 9px 0; font-size: 0.88rem; line-height: 1.45; }
  .tags li div b { color: ${({ theme }) => theme.colors.text}; }
  .tags li div { color: ${({ theme }) => theme.colors.textMuted}; }
  .tag {
    flex: 0 0 auto; min-width: 54px; text-align: center;
    font-weight: 900; font-size: 0.81rem; padding: 4px 8px; border-radius: 8px;
  }
  .tag.boost { color: ${({ theme }) => theme.colors.boost}; border: 1px solid ${({ theme }) => theme.colors.boost}; }
  .tag.llave { color: ${({ theme }) => theme.colors.gold}; border: 1px solid ${({ theme }) => theme.colors.gold}; }
  .tag.pot { color: ${({ theme }) => theme.colors.boost}; border: 1px dashed ${({ theme }) => theme.colors.boost}; }

  .foot { margin: 16px 0 0; font-size: 0.85rem; line-height: 1.5; color: ${({ theme }) => theme.colors.textMuted}; }
  .foot b { color: ${({ theme }) => theme.colors.text}; }

  .ok {
    width: 100%; margin-top: 16px; padding: 13px;
    background: ${({ theme }) => theme.colors.accent}; color: ${({ theme }) => theme.colors.accentText};
    border: none; border-radius: 999px; font-weight: 800; font-size: 1rem;
  }
`;
